<template>
 <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/lxwm/reply">来信回复</router-link> >
      {{ current.title }}
    </div>
    <div class="container-width">
      <ARTICLE
        :current="current"
        :before="before"
        :after="after"
        :showBeforeAfter="showBeforeAfter"
        :showorigin="showorigin"
        @changePage="handleChangePage"
      ></ARTICLE>
    </div>
  </div>
</template>
<script>
import service from "../../../service/lxwm";
import BANNER from "../../../components/banner/lxwm";
export default {
  name: "replyDetail",
  data() {
    return {
      navigationData: [
        {
          name: "给院长写信",
          path: "/lxwm/dean",
        },
        // {
        //   name: "来信统计",
        //   path: "/lxwm/letters",
        // },
        // {
        //   name: "来信选登",
        //   path: "/lxwm/digest",
        // },
        // {
        //   name: "来信回复",
        //   path: "/lxwm/reply",
        // },
        {
          name: "纪检监察",
          path: "/lxwm/discipline",
        },
      ],
      currentPath: "/lxwm/reply", 
      current: {
        title: "",
        description: "",
        releaseDate: "",
        views: "",
        origin: "",
      },
       // 上一篇
       before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showBeforeAfter: false, //是否显示上一篇 下一篇
      showorigin: true, //是否显示来源 发布时间 点击次数
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    let id = this.$route.query.id;
    this.init(id);
  },
  beforeMount() {},
  methods: {
    init(id) {
      let parmes = {
        id: id,
      };
      service.getLetterReplyInfo(parmes, (res) => {
        res.releaseDate = res.releaseDate;
        this.current = { ...res };
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>



<style>
</style>
